/**
 * useOrchestration — Resolve intent code from URL
 *
 * Reads the ?c= intent code from the URL, calls the resolve API,
 * and returns the directive. Never cached — always fresh on mount.
 *
 * @story SCRUM-1450 — 0.1.1.3-02: Render Directive Frontend Integration
 * @returns {{ directive: object|null, loading: boolean, intentCode: string|null }}
 */

import { useState, useEffect } from 'react';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3030';

export function useOrchestration() {
  const [directive, setDirective] = useState(null);
  const [loading, setLoading] = useState(false);
  const [intentCode, setIntentCode] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('c');

    // AC-01: Read c from URL without interpreting it
    // AC-04: No code present → stay on default lander (null directive)
    if (!code) {
      return;
    }

    setIntentCode(code);
    setLoading(true);

    // AC-02: Call resolve endpoint
    // AC-11: No caching — fetch on every mount
    fetch(`${API_BASE_URL}/api/v1/orchestration/resolve?c=${encodeURIComponent(code)}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      cache: 'no-store',
    })
      .then(res => res.json())
      .then(data => {
        setDirective(data);
      })
      .catch(() => {
        // AC-13: API failure → null directive → default lander shown
        setDirective(null);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return { directive, loading, intentCode };
}
